import axios from 'axios';

/**
 * API system config
 * - master → /api           (system 1, DB: nhquavy0_quaythuongbc)
 * - honda  → /apihonda       (system 2, DB: nhquavy0_quaythuongbc_honda)
 *
 * Set via .env:
 *   REACT_APP_API_SYSTEM=master   or   honda
 *   REACT_APP_API_LOCAL=true        for localhost backend
 *   REACT_APP_API_HOST=https://quaythuongbaocuong.com
 */
const API_SYSTEM = process.env.REACT_APP_API_SYSTEM || 'master';

const API_CONFIG = {
  master: {
    prefix: 'api',
    host: process.env.REACT_APP_API_HOST || 'https://quaythuongbaocuong.com',
  },
  honda: {
    prefix: 'apihonda',
    host: process.env.REACT_APP_API_HOST || 'https://quaythuongbaocuong.com',
  },
};

const { prefix, host } = API_CONFIG[API_SYSTEM] || API_CONFIG.master;

export const isLocal = process.env.REACT_APP_API_LOCAL === 'true';

export const apiPrefix = prefix;

export const api = axios.create({
  baseURL: isLocal
    ? `http://localhost:5000/${prefix}`
    : `${host}/${prefix}`,
});

export const resolveAssetUrl = (url) => {
  if (!url) return null;
  if (url.startsWith('http')) return url;

  const origin = api.defaults.baseURL.replace(/\/api(honda)?\/?$/, '');
  return `${origin}${url.startsWith('/') ? url : `/${url}`}`;
};

export const fetchBackgroundUrl = async () => {
  const response = await api.get('/settings/background');
  return resolveAssetUrl(response.data?.url);
};

export const uploadBackground = async (file) => {
  const formData = new FormData();
  formData.append('background', file);

  const response = await api.post('/settings/background', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

  return resolveAssetUrl(response.data?.url);
};
